import PropTypes from 'prop-types'

import defaultAdvisorAvatar from '../../../../../shared_assets/default-advisor-avatar.svg'

const FuneralHomeContactCard = ({firmLogoUrl, firmName}) => (
  <div className='funeral-home-contact-card'>
    {firmName && <div className='funeral-home-name'>{firmName}</div>}
    <img alt='' src={firmLogoUrl ? firmLogoUrl : defaultAdvisorAvatar} />
  </div>
)

FuneralHomeContactCard.propTypes = {
  firmLogoUrl: PropTypes.string,
  firmName: PropTypes.string.isRequired
}

export default FuneralHomeContactCard
